import { DEFAULT_PAGING } from "../constant/constant";
import { camelCase, snakeCase } from "lodash";

export const RenderHTML = ({ HTML }) => (
  // eslint-disable-next-line react/no-danger
  <span className="text-red-600" dangerouslySetInnerHTML={{ __html: HTML }} />
);

export const getCurrentUser = () => {
  let user = null;
  try {
    user = localStorage.getItem("roster_user") != null ? JSON.parse(localStorage.getItem("roster_user")) : null;
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentUser -> error", error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem("roster_user", JSON.stringify(user));
    } else {
      localStorage.removeItem("roster_user");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentUser -> error", error);
  }
};

export const setCurrentMunicipal = (municipal) => {
  try {
    if (municipal) {
      let data = {
        municipal_id: municipal?.municipalityId,
        sourced_id: municipal?.sourcedId,
        municipality_name: municipal?.municipalityName,
        activeGigaSchoolSyncType: municipal?.activeGigaSchoolSyncType
      };
      localStorage.setItem("municipal", JSON.stringify(data));
    } else {
      localStorage.removeItem("municipal");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentMunicipal -> error", error);
  }
};

export const getCurrentMunicipal = () => {
  let municipal = null;
  try {
    municipal = localStorage.getItem("municipal") != null ? JSON.parse(localStorage.getItem("municipal")) : null;
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentMunicipal -> error", error);
    municipal = null;
  }
  return municipal;
};

export const getCurrentToken = () => {
  let token = null;
  try {
    token = localStorage.getItem("ROSTER-TOKEN") != null ? JSON.parse(localStorage.getItem("ROSTER-TOKEN")) : null;
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentToken -> error", error);
    token = null;
  }
  return token;
};

export const getCurrentRefreshToken = () => {
  let token = null;
  try {
    token = localStorage.getItem("ROSTER-REFRESH-TOKEN") != null ? JSON.parse(localStorage.getItem("ROSTER-REFRESH-TOKEN")) : null;
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentToken -> error", error);
    token = null;
  }
  return token;
};

export const setCurrentToken = (token) => {
  try {
    if (token) {
      localStorage.setItem("ROSTER-TOKEN", JSON.stringify(token));
    } else {
      localStorage.removeItem("ROSTER-TOKEN");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentToken -> error", error);
  }
};

export const setCurrentRefreshToken = (refreshToken) => {
  try {
    if (refreshToken) {
      localStorage.setItem("ROSTER-REFRESH-TOKEN", JSON.stringify(refreshToken));
    } else {
      localStorage.removeItem("ROSTER-REFRESH-TOKEN");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentToken -> error", error);
  }
};

export const setCurrentImport = (data) => {
  try {
    if (data) {
      let currentData = localStorage.getItem("current_import") !== null ? JSON.parse(localStorage.getItem("current_import")) : [];
      let currentMunicipal = getCurrentMunicipal();
      let findData = currentData.find((item) => item.municipalId === currentMunicipal?.sourced_id);
      let newData = { ...data, municipalId: currentMunicipal?.sourced_id };

      if (!findData) {
        currentData.push(newData);
      } else {
        let filterData = currentData.filter((item) => item.municipalId !== currentMunicipal?.sourced_id);
        currentData = [...filterData, newData];
      }

      localStorage.setItem("current_import", JSON.stringify(currentData));
    } else {
      localStorage.removeItem("current_import");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentImport -> error", error);
  }
};

export const setAllCurrentImport = (data) => {
  try {
    if (data) {
      localStorage.setItem("current_import", JSON.stringify(data));
    } else {
      localStorage.removeItem("current_import");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setAllCurrentImport -> error", error);
  }
};

export const getCurrentImport = (municipalId) => {
  let data = null;
  try {
    let getData = localStorage.getItem("current_import") != null ? JSON.parse(localStorage.getItem("current_import")) : null;

    if (getData) {
      data = getData.find((item) => item?.municipalId === municipalId);
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentImport -> error", error);
    data = null;
  }
  return data;
};


export const setCurrentSubmitProgress = (data) => {
  try {
    if (data) {
      let currentData = localStorage.getItem("current_submit") !== null ? JSON.parse(localStorage.getItem("current_submit")) : [];
      let currentMunicipal = getCurrentMunicipal();
      let findData = currentData.find((item) => item.municipalId === currentMunicipal?.sourced_id && item?.type === data?.type);
      let newData = { ...data, municipalId: currentMunicipal?.sourced_id };

      if (!findData) {
        currentData.push(newData);
      } else {
        let filterData = currentData.filter((item) => item.municipalId !== currentMunicipal?.sourced_id && item?.type !== data?.type);
        currentData = [...filterData, newData];
      }

      localStorage.setItem("current_submit", JSON.stringify(currentData));
    } else {
      localStorage.removeItem("current_submit");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentSubmitProgress -> error", error);
  }
};


export const getCurrentSubmitProgress = (municipalId, type) => {
  let data = null;
  try {
    let getData = localStorage.getItem("current_submit") != null ? JSON.parse(localStorage.getItem("current_submit")) : null;

    if (getData) {
      data = getData.find((item) => item?.municipalId === municipalId && item?.type === type);
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentSubmitProgress -> error", error);
    data = null;
  }
  return data;
};

export const setSyncJobProgress = (jobId, importType = "entra_id", step = "import") => {
  try {
    if (jobId) {
      const data = {
        step: step,
        importType: importType,
        jobId: jobId
      };
      localStorage.setItem("current_sync_job", JSON.stringify(data));
    } else {
      localStorage.removeItem("current_sync_job");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setSyncJobProgress -> error", error);
  }
};

export const getSyncJobProgress = () => {
  let data = null;
  try {
    data = localStorage.getItem("current_sync_job") != null ? JSON.parse(localStorage.getItem("current_sync_job")) : null;
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getSyncJobProgress -> error", error);
    data = null;
  }
  return data;
};

export const removeSyncJobProgress = () => {
  try {
    localStorage.removeItem("current_sync_job");
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : removeSyncJobProgress -> error", error);
  }
};

export const removeCurrentSubmitProgress = () => {
  try {
    let currentMunicipal = getCurrentMunicipal();
    let getData = localStorage.getItem("current_submit") != null ? JSON.parse(localStorage.getItem("current_submit")) : null;
    if (getData) {
      let data = getData.filter((item) => item?.municipalId !== currentMunicipal?.sourced_id);
      if(data){
        localStorage.setItem("current_submit", JSON.stringify(data));
      }
    }
   
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : removeCurrentSubmitProgress -> error", error);
  }
};

export const setCurrentSubmitLgateProgress = (data) => {
  try {
    if (data) {
      let currentData = localStorage.getItem("current_submit_lgate") !== null ? JSON.parse(localStorage.getItem("current_submit_lgate")) : [];
      let currentMunicipal = getCurrentMunicipal();
      let findData = currentData.find((item) => item.municipalId === currentMunicipal?.sourced_id);
      let newData = { jobId: data, municipalId: currentMunicipal?.sourced_id };

      if (!findData) {
        currentData.push(newData);
      } else {
        let filterData = currentData.filter((item) => item.municipalId !== currentMunicipal?.sourced_id);
        currentData = [...filterData, newData];
      }

      localStorage.setItem("current_submit_lgate", JSON.stringify(currentData));
    } else {
      localStorage.removeItem("current_submit_lgate");
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : setCurrentSubmitLgateProgress -> error", error);
  }
};

export const getCurrentSubmitLgateProgress = (municipalId) => {
  let data = null;
  try {
    let getData = localStorage.getItem("current_submit_lgate") != null ? JSON.parse(localStorage.getItem("current_submit_lgate")) : null;

    if (getData) {
      data = getData.find((item) => item?.municipalId === municipalId);
    }
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : getCurrentSubmitLgateProgress -> error", error);
    data = null;
  }
  return data;
};


export const removeCurrentSubmitLgateProgress = () => {
  try {
    let currentMunicipal = getCurrentMunicipal();
    let getData = localStorage.getItem("current_submit_lgate") != null ? JSON.parse(localStorage.getItem("current_submit_lgate")) : null;
    if (getData) {
      let data = getData.filter((item) => item?.municipalId !== currentMunicipal?.sourced_id);
      if(data){
        localStorage.setItem("current_submit_lgate", JSON.stringify(data));
      }
    }
   
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js  : removeCurrentSubmitLgateProgress -> error", error);
  }
};



export const logout = (history) => {
  try {
    localStorage.removeItem("municipal");
    localStorage.removeItem("ROSTER-TOKEN");
    localStorage.removeItem("ROSTER-REFRESH-TOKEN");
    localStorage.removeItem("roster_user");
    localStorage.removeItem("IMPORT_LOG_PAGE");
    localStorage.removeItem("BLOB_SETTING_PAGE");

    history.push("/");
  } catch (error) {
    //console.log(">>>>: src/helpers/utility.js : logout -> error", error);
  }
};

export const unauthorizeUser = (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem("municipal");
    localStorage.removeItem("ROSTER-TOKEN");
    localStorage.removeItem("roster_user");
    window.location.href = "/?user=unauthorize";
  }
};

export const isValidUrl = (url) => {
  try {
    if (url) {
      new URL(url);
    } else {
      return false;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
};

export const paginator = (items, current_page, per_page_items, dataLength = 0) => {
  let page = current_page || 1;
  let per_page = per_page_items || DEFAULT_PAGING;
  let offset = (page - 1) * per_page;
  let paginatedItems = items.slice(offset).slice(0, per_page_items);
  let total_pages = Math.ceil(dataLength / per_page);

  return {
    page: page,
    per_page: per_page,
    pre_page: page - 1 ? page - 1 : null,
    next_page: total_pages > page ? page + 1 : null,
    total: items.length,
    total_pages: total_pages,
    total_item: paginatedItems.length,
    offset,
    data: paginatedItems,
    dataLength,
  };
};

export const camelizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => camelizeKeys(v));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: camelizeKeys(obj[key]),
      }),
      {}
    );
  }
  return obj;
};

export const snakeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => snakeKeys(v));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [snakeCase(key)]: snakeKeys(obj[key]),
      }),
      {}
    );
  }
  return obj;
};

export const setPasswordRule = (user) => {
  const { password, user_id_lgate, user_lgate_password } = user;
  let setPassword = null;
  let passwordValue = null;

  /* jika csv only dan password tidak ada*/
  if (!user_id_lgate && !password) {
    setPassword = true;
    //console.log('password',1)
  }
  /* jika matching tapi kedua nya ga ada */
  if (user_id_lgate && !password && !user_lgate_password) {
    setPassword = false;
    //console.log('password',2)
  }
  /* jika matching dan password tidak ada tapi lgatePasasword ada */
  if (user_id_lgate && !password && user_lgate_password) {
    setPassword = false;
    passwordValue = user_lgate_password;
    //console.log('password',3)
  }

  /* jika matching dan password keduanya ada */
  if (user_id_lgate && password && user_lgate_password) {
    setPassword = false;
    passwordValue = user_lgate_password;
    //console.log('password',4)
  }

  /* jika matching dan password csv ada */
  if (user_id_lgate && password && !user_lgate_password) {
    setPassword = false;
    passwordValue = password;
    //console.log('password',5)
  }

  /* jika csv only dan password ada */
  if (!user_id_lgate && password) {
    setPassword = false;
    passwordValue = password;
    //console.log('password',6)
  }

  return {
    setPassword,
    passwordValue,
  };
};

export const getOrgsIdImport = (orgsData, sourcedIdLgate) => {
  let dt = "";
  for (let i = 0; i < orgsData.length; i++) {
    if (orgsData[i].orgs_id_lgate === sourcedIdLgate) {
      dt = orgsData[i].sourced_id
      i = orgsData.length
    }
  }
  return dt;
};



export const sortByNameASC = (a, b) => {
  // if ( a.name < b.name ){
  //   return -1;
  // }
  // if ( a.name > b.name ){
  //   return 1;
  // }
  // return 0;
  return a.name.localeCompare(b.name, 'jp', { sensitivity: 'base' });
}

export const sortByNameDESC = (a, b) => {
  // if ( a.name > b.name ){
  //   return -1;
  // }
  // if ( a.name < b.name ){
  //   return 1;
  // }
  // return 0;
  return b.name.localeCompare(a.name, 'jp', { sensitivity: 'base' });
}

export const sortByTitleASC = (a, b) => {
  // if ( a.title < b.title ){
  //   return -1;
  // }
  // if ( a.title > b.title ){
  //   return 1;
  // }
  // return 0;
  return a.title.localeCompare(b.title, 'jp', { sensitivity: 'base' });
}

export const sortByTitleDESC = (a, b) => {
  // if ( a.title > b.title ){
  //   return -1;
  // }
  // if ( a.title < b.title ){
  //   return 1;
  // }
  // return 0;
  return b.title.localeCompare(a.title, 'jp', { sensitivity: 'base' });
}

export const alphanumVal = (string) => {
  let regEx = new RegExp("^(?!\\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 @&$]*)?$");
  return regEx.test(string);
}